import React from "react";
import Modal from "../Modal/Modal";
import Button from "../../Atoms/Button/Button";
import _get from 'lodash/get'
import { REMOVE_FAVORITE } from "../../../constants/ContextConstants";
import useStore from "../../../store/useStore";
interface FavOrBestConfirmationModalInterface {
  confirmationModalClose: () => void,
  confirmationModalDetails: any,
  confirmationModalCtaAction: ()=> void
}
const FavOrBestConfirmationModal: React.FC<FavOrBestConfirmationModalInterface> = ({ confirmationModalClose, confirmationModalDetails, confirmationModalCtaAction }) => {
  const {setContextLoader} = useStore();
  return (
    <Modal
      onButtonClick={confirmationModalClose}
      isClosebtn={true}
      title={_get(confirmationModalDetails, 'areYouSureYouWantToDeleteThisFavorite', null)}
    >
      <Button
        testAutoId={REMOVE_FAVORITE}
        className="curbside__okcta secondary__btn"
        onClick={() => {
          setContextLoader({
            buttonId: REMOVE_FAVORITE,
            isLoading: true,
          });
          confirmationModalCtaAction();
        }}
      >
        {_get(confirmationModalDetails, 'removeFavorite', null)}
      </Button>
      <Button
        testAutoId="cancelRemoveFavorite"
        className="curbside__okcta curbside__okcta secondary__btn secondary__btn--white"
        onClick={confirmationModalClose}
      >
        {_get(confirmationModalDetails, 'cancel', null)}
      </Button>
    </Modal>
  );
};
export default FavOrBestConfirmationModal;